export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-thumbnail-480-17cecedfec8765f9455ebfd05ac229a9.png";